module.exports = __webpack_public_path__ + "img/icon-keystore-mew.b4b1615e.png";